import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
import NESAHeader from '../Inc/NESAHeader';
import NESAFooter from '../Inc/NESAFooter';
import './style.css';
import * as actions from '../../actions/index';
import warningAlert from './warning-alert.png'
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import InputMask from 'react-input-mask'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { history } from '../../container/History';
import Iframe from '../HOC/iframe'
import moment from 'moment'
import base64 from 'base-64'
import MembershipAlumniInfo from '../Inc/MembershipAlumniInfo'
import CustomPopupModal from '../Inc/customPopupModal'
import FullPageSpinner from '../Inc/FullPageSpinner'

import ScoutsPrimaryOrAlternateAddress from './ScoutsAddress'
import { CheckCircleTwoTone } from '@ant-design/icons';
import { Steps, Button, Tooltip, Spin, Row, Typography, DatePicker, Switch, Col, Card, Modal, Form, Input, Radio, Checkbox, Select, Icon, Divider } from 'antd';
import NewEagleGreetingsModal from './NewEagleGreetingsModal';


const FormItem = Form.Item;
const Step = Steps.Step;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const CHASE_URL = process.env.REACT_APP_CHASE
const PENDING_MEMBERSHIP_TEXT = process.env.REACT_APP_PENDING_MEMBERSHIP_TEXT;
const CONFIRM_MEMBERSHIP_TEXT = process.env.REACT_APP_CONFIRM_MEMBERSHIP_TEXT;

const INDIVIDUAL_PURCHASE = JSON.parse(process.env.REACT_APP_INDIVIDUAL_PURCHASE);
const { Text } = Typography;

let BackBtn = false
const NESA_MID = process.env.REACT_APP_NESA_MID;
const TRANSACTION_FEE = process.env.REACT_APP_TRANSACTION_FEE;

const failedToLoadLookup_Popup_primaryConent = "We were unable to load required"
const failedToLoadLookup_secondaryConent = "Please try again."

const deceasedPopup_primaryConent = "We’re sorry, but NESA memberships cannot be issued in the name of a deceased individual."
const deceasedPopup_secondaryConent = "If you have any questions or need further assistance, please contact us at NESA@scouting.org."

class PurchaseMembershipForm extends React.Component {
    // selectphonecountryIDRef = createRef() //AAG-971 Remove 'Scout's Phone Number from NESA application process
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            value: 1,
            userDetails: "",
            TotalAmount: 0,
            SelectedMembership: 0,
            SelectedMembershipID: 0,
            SelectedMembershipName: '',
            SelectedMembershipPrice: 0,
            RushShipping: false,
            shipping_handlingCharge: '',
            isPayTransactionFees: false,
            ShowPaymentSummary: true,
            isDeceasedPerson: false,
            transactionFee: 0,
            NonUS: false,
            EagleInfo: '',
            Address: '',
            ethnic: '',
            hideNext: true,
            receipt_loading: false,
            ReceiptPara1: "",
            profilevalues: {},
            ReceiptPara2: "",
            minutes: 0,
            seconds: 20,
            ReceiptEmail: '',
            isVaildDate: '',
            showResultModal: false,
            EagleResults: [],
            memberSelectedKey: 0,
            selectedRecord: undefined,
            NoResultsMatchProfile: false,
            NoResultsFound: false,
            personGUID: undefined,
            firstname: '',
            middlename: '',
            lastname: '',
            address1: '',
            address2: '',
            address3: '',
            city: '',
            zip: '',
            data: '',
            memberId: '',
            scouts_DOB: '',
            // phoneCountryId: '', //AAG-971 Remove 'Scout's Phone Number from NESA application process
            // PhoneNumber: '',
            scouts_DOB_MaskChar: null,
            scouts_BOR: null,
            scoutsCountry: '616',
            membershipRecords: {},
            PromocodeApplied: false,
            isPromocodeRemoved: false,
            isPromoCodeEditable: true,
            DiscountAmount: 0,
            DiscountCode: '',
            createdPayments: {},
            getValidEagleState: undefined,
            getValidEagleCity: undefined,
            existingLifePlan: false,
            isShippingAddress: false,
            doesShowNewMemberGreetings: false,
            isApplicableForNewEagle: false,
            lookupsLoaded: false,
            showLookupError: false,
            pageLoader: true,
            failedLookups: []
        };

        this.ethnicities = this.ethnicities.bind(this)
        window.showPurchaseReceiptComponent = this
    }

    countries = () => {
        if (this.props.countries) {
            let countriesarray = this.props.countries.sort((a, b) => a.name - b.name)
            return countriesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.name}</option>
                )
            })
        }
    }
    
     getPhoneCode = () => {
        if (this.props.phonecode) {
            let phonecode = this.props.phonecode.sort((a, b) => a.name.localeCompare(b.name))
             return phonecode.map((k, index) => {
                return (
                     <option key={index} value={k.id}>{k.name}</option>
                )
           })
       }
     }

     changeScoutsCountry = (e) => {
        this.setState({
            scoutsCountry: e,
        })
     }
    //  renderAddressFrames= () => {
    //     // if(this.state.scoutsCountry == '616' || this.state.scoutsCountry == 616 || this.state.scoutsCountry == '') 
    //             return <ScoutsPrimaryOrAlternateAddress 
    //             form={this.props.form}
    //             scoutsCountry = {this.state.scoutsCountry}  
    //             phoneCountryId={this.state.phoneCountryId}
    //             changeScoutsCountryEventHandler = {this.changeScoutsCountry}
    //             />
    //             // return this.render_USA_address() 
    //             // else return this.render_nonUSA_address()
                
    //  }

     renderPrimaryOrAlternateAddress = () => {

        return <ScoutsPrimaryOrAlternateAddress 
        form={this.props.form}
        selectedRecord = {this.state.selectedRecord}
        scoutsCountry = {this.state.scoutsCountry}  
        phoneCountryId={this.state.phoneCountryId}
        changeScoutsCountryEventHandler = {this.changeScoutsCountry}
        isShippingAddress = {this.state.isShippingAddress}
        changeAlternateShippingAddressEventHandler = {this.changeAlternateShippingAddress}
        />
        // const primaryHomeAddress = 'Your Primary Home Address';
        // const alternateShippingAddress = "Your 'Ship to' Address";
        // return (
        //     <div>
        //         <Card
        //             className="centered"
        //             title={this.state.isShippingAddress ? alternateShippingAddress : primaryHomeAddress}
        //         >
        //             {!this.state.isShippingAddress && this.renderAddressFrames()}
        //             {/* {this.addressInfo()} */}

        //             <div className='margin-10'>
        //                 <Checkbox
        //                     onClick={(e) => this.changeAlternateShippingAddress(e, 'confirmationBox')}
        //                     className='ShippingAlternateCheckbox'
        //                 >
        //                     Alternate Shipping Address
        //                     <label>
        //                         awards and certificates will be shipped to your home address unless Alternate
        //                         Shipping Address is selected.
        //                     </label>
        //                 </Checkbox>

        //                 {this.state.isShippingAddress && this.renderAddressFrames()}

        //             </div>
        //         </Card>
        //     </div>
        // )
     }

     changeAlternateShippingAddress = (e) => {
        if(e.target.checked) {
            this.setState(({isShippingAddress: true})) 
        }else {
            this.setState(({isShippingAddress: false}))
        }
     }
     
    showLoadingReceipt = () => {
        this.setState({
            receipt_loading: true
        })
        this.loadingInterval = setInterval(() => {
            const { seconds, minutes } = this.state

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.loadingInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    }

    getValidEagleStateHandler = (eagleState, eagleCity) => {
        let getValidEagleState, getValidEagleCity;
        let getEagleState = this.props.allstates.filter(state => {
            return state.short == eagleState
        })
        if (getEagleState.length == 0) {
            getValidEagleState = null;
            getValidEagleCity = null
        }
        else {
            getValidEagleState = eagleState;
            getValidEagleCity = eagleCity
        }

        return { getValidEagleState, getValidEagleCity }
    }

    // checkApplicableForNewEagle = (eagleBOR) => {
    //     const currentDate = new Date();//AAG-1240 -  A NEW EAGLE STATUS IS NOW EXTENDED FOR A YEAR FROM THE BOR DATE.
    //     const newEagleApplicablePeriod = moment(eagleBOR).add(1, 'Year').subtract(1, 'day').format('MM/DD/YYYY');

    //     return Boolean(moment(currentDate).isSameOrAfter(eagleBOR) && moment(currentDate).isSameOrBefore(newEagleApplicablePeriod));

    // }

    checkApplicableForNewEagle = (eagleBOR) => {
        if (!eagleBOR) return false;
    
        const bor = moment(eagleBOR).startOf('day');
        const today = moment().startOf('day');
        const oneYearAgo = moment().subtract(1, 'year').startOf('day');
    
        return bor.isBetween(oneYearAgo, today, undefined, '[]');
    }

    selectMembership = (id, name, amt, SH_Fee) => {
        let transactionFee = ((amt + SH_Fee) * TRANSACTION_FEE) / 100;
        transactionFee = (Math.round(transactionFee * 100) / 100).toFixed(2);
        let total = (Math.round((amt + SH_Fee) * 100) / 100).toFixed(2);

        this.setState({
            SelectedMembershipID: id,
            SelectedMembershipName: name,
            SelectedMembershipPrice: (Math.round(amt * 100) / 100).toFixed(2),
            shipping_handlingCharge: (Math.round(SH_Fee * 100) / 100).toFixed(2),
            transactionFee: transactionFee,
            TotalAmount: total
        });
        const current = this.state.current + 1;
        this.setState({ current });
        // this.props.actions.getEthnicities()
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
        // this.props.actions.getEthnicities()
    }

    prev() {
        BackBtn = true;
        const current = this.state.current - 1;
        let length = this.state.EagleResults.length;
        if (current == 1 && length > 1) {
            this.setState({
                current,
                showResultModal: true
            });
        } else if (current == 1 && length == 1) {
            this.setState({
                current,
                // NoResultsMatchProfile: true
            })
        }
        else if (current == 2) {
            this.props.form.setFieldsValue({
                promocode: '',
            });
            let transactionFee = (((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
            let TotalAmount = (parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge) + (this.state.isPayTransactionFees ? parseFloat(transactionFee) : 0)).toFixed(2)

            this.setState({
                current,
                // transactionFee,
                TotalAmount: TotalAmount,
                isPromocodeRemoved: true,
                PromocodeError: false,
                PromocodeApplied: false,
                isPromoCodeEditable: true,
                DiscountAmount: 0,
                DiscountCode: ''

                // TotalAmount: (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
            })
        }
        else if (current == 3 || current == 4) {
            // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);

            // let transactionFee = (((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
            this.setState({
                current,
                // DiscountAmount: 0,
                // TotalAmount: total,
                // transactionFee,
                // PromocodeApplied: false,
                // PromocodeError: false,
                // isPayTransactionFees: false,
            })
        }
        else {
            this.setState({ current });
        }
        // this.props.actions.getEthnicities()
    }

    RushShipping = (e) => {
        if (e.target.checked) {
            this.setState({
                RushShipping: true,
                TotalAmount: parseInt(this.state.TotalAmount) + 40
            })
            this.props.actions.RegisterMembership(this.state.profilevalues, this.props.profileinfo, this.state.SelectedMembershipID, this.state.EagleInfo, true, this.state.TotalAmount + 40, "NESA", NESA_MID, "SELF-NESA")
        } else {
            this.setState({
                RushShipping: false,
                TotalAmount: parseInt(this.state.TotalAmount) - 40
            })
            this.props.actions.RegisterMembership(this.state.profilevalues, this.props.profileinfo, this.state.SelectedMembershipID, this.state.EagleInfo, false, this.state.TotalAmount - 40, "NESA", NESA_MID , "SELF-NESA")
        }

    }

    statesID = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.short}</option>
                )
            })
        }
    }
    promoButtons = () => {
        if (this.state.PromocodeApplied && this.state.isPromoCodeEditable) {
            return <Input disabled autoComplete="off" addonAfter={<Button style={{ backgroundColor: '#e60b2f', color: '#fff', borderColor: 'transparent' }} loading={this.state.applingPromocode} onClick={() => this.handlePromoRemove()} icon="close">{this.state.removingPromocode ? 'Removing' : 'Remove'}</Button>} size="small" className='promocodeInput' placeholder="Code" />
        }
        else if (this.state.isPromoCodeEditable) {
            return <Input autoComplete="off" addonAfter={<Button type="primary" loading={this.state.applingPromocode} htmlType='submit' icon="check">Apply</Button>} size="small" className='promocodeInput' placeholder="Code" />
        }
        else if (!this.state.isPromoCodeEditable) {
            return <Input disabled autoComplete="off" addonAfter={<Button type="default" className='successBtn' icon="check-circle">applied</Button>} size="small" className='promocodeInput' placeholder="Code" />
        }
    }

    splitPhoneNumber(phoneNumber) {
        if (!phoneNumber) return undefined; // Return undefined if the phone number is not provided
        
        if (phoneNumber.length !== 10) return null; // Check if the number is valid (10 digits for US)
        
        // Split the number into components
        const areaCode = phoneNumber.substring(0, 3);
        const prefix = phoneNumber.substring(3, 6);
        const lineNumber = phoneNumber.substring(6);
    
        return {
            areaCode,
            prefix,
            lineNumber
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {

            // let address = this.props.profileinfo.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
            // if (!address) {
            //     Modal.warning({
            //         title: 'Required!',
            //         content: 'You don\'t have any primary address. Please update the address information.',
            //     });
            //     return false
            // }
            // else

            if (!err) {
                let isRush = false
                // let person_ethnic = values.ethnic
                // let ethnicitiesArray = this.props.ethnicities
                // let ethnic = undefined;

                // // this.setState({
                // //     profilevalues: values
                // // })
                // ethnicitiesArray.map((k, index) => {
                //     if (k.short == person_ethnic) {
                //         values.ethnic = k.id
                //         if (this.state.ethnic == '') {
                //             ethnic = k.short
                //             // this.setState({
                //             //     ethnic: k.short
                //             // })
                //         }
                //     } else if (k.name == person_ethnic) {
                //         values.ethnic = k.id
                //         if (this.state.ethnic == '') {
                //             ethnic = k.short
                //             // this.setState({
                //             //     ethnic: k.short
                //             // })
                //         }
                //     }
                //     else {
                //         console.log('no ethnic found')
                //     }
                // })

                //adding membershiptype
                values.MembershipType = this.state.SelectedMembershipID

                let selectedRecord = { ...this.state.selectedRecord }
                selectedRecord.dob = this.state.scouts_DOB
                
                values.dob = this.state.scouts_DOB
                values.scout_state = this.state.getValidEagleState
                values.scout_city = this.state.getValidEagleCity

                // const { areaCode = "", prefix = '', lineNumber = '' } = this.splitPhoneNumber(values.phone);
                // values.areaCode = areaCode;
                // values.prefix = prefix;
                // values.lineNumber = lineNumber;

                if(values.phone) {
                    if(values.phone.length == 4) {
                        values.lineNumber = values.phone || undefined;
                    } else {
                        const { areaCode, prefix, lineNumber } = this.splitPhoneNumber(values.phone) || {};
                        values.areaCode = areaCode || undefined;
                        values.prefix = prefix || undefined;
                        values.lineNumber = lineNumber || undefined;
                    }
                }
                this.setState({
                    memberId: selectedRecord.memberId,
                    firstname: selectedRecord.firstName,
                    middlename: selectedRecord.middleName,
                    lastname: selectedRecord.lastName,
                    address1: values.addressline1,
                    address2: values.addressline2 ? values.addressline2 : null,
                    address3: values.addressline3 ? values.addressline3 : null,
                    city: values.city ? values.city : null,
                    zip: values.zipcode ? values.zipcode : null,
                    data: values,
                    selectedRecord
                })

                values.isPayTransactionFees = this.state.isPayTransactionFees
                values.transactionFee = this.state.transactionFee
                values.isUpdatePrimaryAddress = !this.state.isShippingAddress;

                let amount = (parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge) + (this.state.isPayTransactionFees ? parseFloat(this.state.transactionFee) : 0)).toFixed(2)
                this.props.actions.RegisterMembership(values, selectedRecord, this.state.SelectedMembershipID, null, isRush, parseFloat(amount), "NESA", NESA_MID, 'SELF-NESA', this.state.isApplicableForNewEagle)

                let statesarray = this.props.allstates
                statesarray.map((k, index) => {
                    if (k.id == values.state)
                        return values.stateName = k.short
                })

                this.setState({
                    // current: 3,
                    userDetails: values
                })
            }
        })
    }
    calculateFee = () => {
        // let transactionFee = ((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100
        // let totalPrice = this.state.isPayTransactionFees ? parseFloat(this.state.TotalAmount) - transactionFee : parseFloat(this.state.TotalAmount) + transactionFee;
        // totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
        this.setState({
            isPayTransactionFees: !this.state.isPayTransactionFees,
            // TotalAmount: totalPrice
        })
    }

    InitTrans = () => {
        
        this.props.actions.InitOrbitalPayments(this.state.TotalAmount, 'NESA', NESA_MID, this.state.membershipRecords, this.state.data.email, 
        // this.state.PhoneNumber, //AAG-971 Remove 'Scout's Phone Number from NESA application process
        this.state.createdPayments, this.state.isShippingAddress)
        if (this.state.PromocodeApplied) {
            this.setState({
                isPromoCodeEditable: false
            })
        }
    }

    newEagleDiscountMsg = () => {
        const { shoppingCartList } = this.props;
        if (shoppingCartList) {
            const isPromoCodeAdded = shoppingCartList.shoppingCart.some(cartList =>
                cartList.feeStructureCode === "NESA5NE-5Year" || cartList.feeStructureCode === "NESANE-LT"
            );
            if (isPromoCodeAdded) {
                return (
                    <div style={{ display: 'inline' }}>
                        <span className='Promocode-Added'>&#40;with New Eagle Discount&#41;</span>
                    </div>
                );
            }
        }
        return null;
    }

    renderPaymentSummary = () => {
        const { getFieldDecorator } = this.props.form;
        const { nesa_reg, nesa_levels } = this.props;

        return (<div className="payment-summary centered" style={{ marginBottom: '40px' }} >
            <Form className="search-form alumni-ui">
                <Row type="flex" justify="center" align="center">


                    <Col className="card-margin summary-card" span={24}>
                        <Card
                            className="centered"
                            title="SUMMARY"

                        >
                            <div style={{ padding: "10px 30px" }} className='eagle-info-pad'>
                                <Row className='eagle-info-row'>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="Summary-title-txt" style={{ fontSize: '14px' }}>Eagle Info</div>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                        <div className="verified"><Icon type="check-circle" /> Verified</div>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname}</div>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                        <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.memberId}</div>
                                    </Col>
                                </Row>
                                <Divider style={{ margin: '10px 0px' }} />

                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="Summary-title-txt" style={{ fontSize: '14px' }}>LEVEL</div>
                                    </Col>
                                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <div className="verified"><Icon type="check-circle" /> {this.state.SelectedMembershipName}</div>
                            </Col> */}

                                </Row>
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                         <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.SelectedMembershipName} {this.newEagleDiscountMsg()}</div>
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                        <div className="summary-label-txt">$ {this.state.SelectedMembershipPrice}</div>
                                    </Col>
                                </Row>
                                <Divider style={{ margin: '10px 0px' }} />

                               
                                        <Form onSubmit={this.handlePromoSubmit}>
                                            <div className='promotions'>
                                                <Row type='flex' align='middle' className='promotion-row'>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                        <div className="summary-label-txt">Promotion code</div>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                        {getFieldDecorator('promocode', {
                                                            initialValue: this.state.DiscountCode ? this.state.DiscountCode : "",
                                                            rules: [{ required: false }],
                                                        })(
                                                            this.promoButtons()
                                                            // this.state.PromocodeApplied && this.state.isPromoCodeEditable ?
                                                            //     <Input autoComplete="off" addonAfter={<Button type="primary" loading={this.state.applingPromocode} onClick={() => this.handlePromoRemove()} icon="check">{this.state.removingPromocode? 'Removing' : 'Remove'}</Button>}  size="small" className='promocodeInput' placeholder="Code" />
                                                            // :
                                                            // this.state.isPromocodeRemoved && this.state.isPromoCodeEditable ?
                                                            //     <Input  autoComplete="off" addonAfter={ <Button type="default"  className='successBtn' icon="check-circle">apply</Button>} size="small" className='promocodeInput' placeholder="Code" /> 
                                                            // : <Input  autoComplete="off" addonAfter={<Button type="primary" loading={this.state.applingPromocode} htmlType='submit' icon="check">Apply</Button>} size="small" className='promocodeInput' placeholder="Code" />  

                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row type='flex' align='middle' justify='end'>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                        {(this.state.PromocodeError && !this.state.PromocodeApplied) && <Text type="danger"><Icon type="info-circle" /> {this.props.PromocodeError ? this.props.PromocodeError.errorDesc ? this.props.PromocodeError.errorDesc : this.props.PromocodeError : "Invalid Promo Code!"}</Text>}
                                                        {this.state.PromocodeApplied && <Text type="success"><Icon type="check-circle" /> Promo Code added successfully!</Text>}
                                                    </Col>
                                                </Row>
                                                {this.state.DiscountAmount != 0 && <Row >
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                        <div className="summary-label-txt" style={{ fontSize: '14px' }} >Discount Amount</div>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                        <div className="summary-label-txt green-txt"> -$ {this.state.DiscountAmount}</div>
                                                    </Col>
                                                </Row>}
                                            </div>
                                            {this.state.PromocodeApplied && <Row >
                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                    <div className="summary-label-txt" style={{ fontSize: '14px' }} >Membership Cost</div>
                                                </Col>

                                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                    <div className="summary-label-txt">$ {parseFloat(parseFloat(this.state.SelectedMembershipPrice) - parseFloat(this.state.DiscountAmount)).toFixed(2)}</div>
                                                </Col>
                                            </Row>}
                                        </Form>
                                        <Divider style={{ margin: '10px 0px' }} />
                                   
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.SelectedMembershipName} Shipping/Handling</div>
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                        <div className="summary-label-txt">$ {this.state.shipping_handlingCharge}</div>
                                    </Col>
                                </Row>
                                {this.state.isPayTransactionFees &&
                                    <Row >
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div className="summary-label-txt" style={{ fontSize: '14px' }} >Transaction Fee</div>
                                        </Col>

                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                            <div className="summary-label-txt">$ {this.state.transactionFee}</div>
                                        </Col>
                                    </Row>
                                }
                                <Divider style={{ margin: '10px 0px' }} />
                                <Row style={{ display: 'flex', alignItems: 'center' }} className='total-charge'>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="summary-label-txt" style={{ fontSize: '14px' }}>
                                            TOTAL CHARGE
                                </div>
                                        {/* <div className="summary-label-txt" style={{ fontSize: '14px' }} ></div> */}
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                        <div className="summary-price">$ {this.state.TotalAmount}</div>
                                    </Col>
                                </Row>
                                {/* 
                            <Row >
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname}</div>
                                </Col>
                            </Row> */}
                                {/* <Row style={{ display: 'flex', justifyContent: 'center' }}>
                                <Col className='xs-center sm-center' xs={14} sm={14} md={8} lg={8} xl={8}>
                                    {this.renderSearchButton()}
                                </Col>
                            </Row> */}
                            </div>

                        </Card>
                    </Col>
                </Row>

                <div className="steps-action centered" style={{ width: '100%' }}>
                    <Row style={{ position: "unset" }}>
                        <Col xs={24} sm={24} md={14} lg={14} xl={14}  >
                            <div className="text-result pointer"
                                style={{ marginTop: "55px", marginBottom: '55px' }}
                                onClick={() => {
                                    // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                    // this.setState({
                                    //     current: 0,
                                    //     ShowPaymentSummary: true,
                                    //     isPayTransactionFees: false,
                                    //     TotalAmount: total
                                    // })
                                    // history.push('/purchase-membership')
                                    this.prev()
                                }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Info</div>
                        </Col>
                        {/* <Col className='xs-center sm-center ' xs={24} sm={24} md={14} lg={14} xl={14} offset={2}>
                                                        <FormItem>
                                                            <Button type="primary" style={{ width: '100%' }} className='back-btn' onClick={() => this.prev()}>This is not me</Button>
                                                        </FormItem>
                                                    </Col> */}
                        <Col className='xs-center sm-center' xs={24} sm={24} md={8} lg={8} xl={8} offset={1}>
                            {this.renderPayNowButton()}
                        </Col>
                    </Row>
                </div>
            </Form>
        </div>)
    }
    renderIframe = () => {
        if (this.props.initloading == true) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Chase Payments..." />
                </Col>
            </Row>
        }
        else if (this.props.registration_loading) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Please Wait..." />
                </Col>
            </Row>
        }
        else if (this.props.initTransaction) {
            return <Row className="chase-payment">
                <Col span={24}>
                    <Iframe src={`${CHASE_URL}` + this.props.initTransaction.uID} height="700px" width="100%" />
                </Col>
            </Row>
        }
        else {
            return <Row>
                <Col span={24} className="centered margin-top-30">
                    <div className="margin-bottom-20">Unable to load the payment form. Please try again.</div>
                    <Button type="primary" onClick={() => this.InitTrans()}>Try Again</Button>
                </Col>
            </Row>
        }
    }


    showReceipt = (RegID, response) => {
        setTimeout(
            function () {
                // this.props.actions.changeMembershipStatusToProcessed(RegID, this.state.memberId, false);
                this.props.actions.getRegStatusandSendReceipt(RegID, this.state.userDetails, "NESA", this.state.ReceiptEmail, response, false, this.state.memberId, !this.state.isShippingAddress)
            }
                .bind(this),
            15000
        );
    }

    renderReceiptpage = () => {
        if (this.props.regstatus) {
            // if (this.props.regstatus[0].applicationStatusId == "4") {
            //     this.setState({
            //         ReceiptPara1: PENDING_MEMBERSHIP_TEXT
            //     })
            // }
            // if (this.props.regstatus[0].applicationStatusId == "21") {
            //     this.setState({
            //         ReceiptPara1: CONFIRM_MEMBERSHIP_TEXT
            //     })
            // }
            this.setState({
                current: 5
            })
        }
    }

    renderLevels = () => {
        console.log('purchase productprice', this.props.productprice)

        if (this.props.productprice_loading || this.props.nesa_levels_loading) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading NESA levels..." />
                </Col>
            </Row>
        }
        if (this.props.nesa_levels && this.props.productprice) {
            let nesalevels = this.props.nesa_levels
            let productprice = this.props.productprice;

            return nesalevels.map((k, index) => {
                let price = 0;
                let shipping_handlingCharge = 0;
                let shipping_StructureCode;
                let productname = (k.name).replace(/-/g, " ")
                productprice.map((j, index) => {
                    if (k.name == j.feeStructureCode) {
                        price = (Math.round(j.termFee * 100) / 100).toFixed(2);
                        if (k.name.includes("5Year")) { //if (k.name == "NESA-Silver-5Year") {
                            shipping_StructureCode = "NESA5SH"
                        } else if (k.name.includes("Lifetime")) { //  } else if (k.name == "NESA-Gold-Lifetime") {
                            shipping_StructureCode = "NESALIFESH"
                        }
                    }
                })

                productprice.map((j, index) => {
                    if (shipping_StructureCode == j.feeStructureCode) {
                        shipping_handlingCharge = (Math.round(j.termFee * 100) / 100).toFixed(2);
                    }
                })

                return <Col xs={24} sm={24} md={12} lg={12} className='welcome-nesa-padding'>
                    <div className="membership-card">
                        <img src="../NESA.png" className='NESA-logo' />
                        <span className="membership-level">{productname == 'NESA 5Year' ? 'NESA 5-year' : productname}</span>
                        <span className="membership-price">$ {price}</span>
                        <Button className="membership-start" onClick={() => this.selectMembership(k.id, productname, Number(price), Number(shipping_handlingCharge))}>START</Button>
                    </div>
                </Col>
            })
        }
    }

    notDefaultDate = (rule, value, callback) => {
        const { form } = this.props;
        if (value && moment(value).format('DD/MM/YYYY') == '01/01/1901') {
            callback('Not a valid date!');
        } else {
            callback();
        }
    };

    // render_nonUSA_address = () => {

    //     const { getFieldDecorator } = this.props.form;
    //     const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };

    //     return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem
    //                     label="Your Country"
    //                 >
    //                     {getFieldDecorator('countryId', {
    //                         initialValue: this.state.scoutsCountry ? `${this.state.scoutsCountry}` : "616",
    //                         rules: [{ required: true, message: 'Enter Your Country!' }],
    //                     })(
    //                         <Select
    //                             // className={this.state.scoutsCountry ? 'input-disabled' : ''}
    //                             // disabled={this.state.scoutsCountry ? true : false}
    //                             showAction={['focus', 'click']}
    //                             showSearch
    //                             style={{ width: '100%' }}
    //                             placeholder="Select a Country"
    //                             optionFilterProp="children"
    //                             onChange={(e) => {
    //                                 this.changeScoutsCountry(e)
    //                             }}
    //                             filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    //                         >
    //                             {this.countries()}
    //                         </Select>
    //                     )}
    //                 </FormItem>
    //             </Col>

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label={(
    //                         <span>
    //                             Address Line 1&nbsp;
    //                             <Tooltip placement="top" title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)">
    //                                 <Icon type="info-circle-o" />
    //                             </Tooltip>
    //                         </span>
    //                     )}
    //                 >
    //                     {getFieldDecorator('addressline1', {
    //                         // initialValue: this.state.selectedRecord.address1 ? this.state.selectedRecord.address1 : "",
    //                         rules: [{ required: true, message: 'Enter Your Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 1"
    //                         // className={this.state.selectedRecord.address1 ? 'input-disabled' : ''}
    //                         // disabled={this.state.selectedRecord.address1 ? true : false}
    //                         />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     style={{ marginBottom: '0px' }}
    //                     label={(
    //                         <span>
    //                             Address Line 2&nbsp;
    //                             <Tooltip placement="top" title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)">
    //                                 <Icon type="info-circle-o" />
    //                             </Tooltip>
    //                         </span>
    //                     )}
    //                 //extra="City, Territory, Postal Code, Country"
    //                 >
    //                     {getFieldDecorator('addressline2', {
    //                         // initialValue: this.state.selectedRecord.address2 ? this.state.selectedRecord.address2 : "",
    //                         rules: [{ required: false, message: 'Enter Your Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 2"
    //                         // className={this.state.selectedRecord.address2 ? 'input-disabled' : ''}
    //                         // disabled={this.state.selectedRecord.address2 ? true : false} 
    //                         />
    //                     )}
    //                 </FormItem>
    //             </Col>

    //         </Row>

    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     style={{ marginBottom: '0px' }}
    //                     label={(
    //                         <span>
    //                             Address Line 3&nbsp;
    //                              <Tooltip placement="top" title="List the city, territory, postal code and country according to country standards (Southampton, SO53 5PD, UK; Vancouver, BC V5X 2H6">
    //                                 <Icon type="info-circle-o" />
    //                             </Tooltip>
    //                         </span>
    //                     )}
    //                     extra="City, Territory, Postal Code, Country"
    //                 >
    //                     {getFieldDecorator('addressline3', {
    //                         // initialValue: this.state.selectedRecord.address3 ? this.state.selectedRecord.address3 : "",
    //                         rules: [{ required: true, message: 'Enter Your Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 3"
    //                         // className={this.state.selectedRecord.address3 ? 'input-disabled' : ''}
    //                         // disabled={this.state.selectedRecord.address3 ? true : false} 
    //                         />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             {/* //AAG-1026 ADDED BACK - 'Scout's Phone Number from NESA application process */}
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Your Phone"
    //                 >
    //                     {getFieldDecorator('phone', {
    //                         // initialValue: this.state.selectedRecord.phone ? (this.state.PhoneNumber) ? this.state.PhoneNumber.toString() : this.state.selectedRecord.phone.toString() : '',
    //                         rules: [{ required: true, min: 10, max: 10, message: 'Enter Your Phone Number!' },
    //                         {
    //                             pattern: new RegExp("^[0-9]*$"),
    //                             message: "Phone Number must be all numeric!"
    //                         }],
    //                     })(
    //                         <Input
    //                             // className={this.state.PhoneNumber ? 'input-disabled' : ''}
    //                             // disabled={(this.state.PhoneNumber) ? true : false}
    //                             addonBefore={
    //                                 getFieldDecorator('phonecountryID', {
    //                                     rules: [{ required: true, message: 'Select Phone Country ID' }],
    //                                     initialValue: this.state.phoneCountryId ? `${this.state.phoneCountryId}` : "636",
    //                                     // initialValue:  "636",
    //                                 })(
    //                                     <Select style={{ width: 120 }} ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()}>
    //                                         {this.getPhoneCode()}
    //                                     </Select>
    //                                 )
    //                             } />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Your Email"
    //                 >
    //                     {getFieldDecorator('email', {
    //                         // initialValue: this.state.selectedRecord.email ? this.state.selectedRecord.email : "",
    //                         rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
    //                     })(
    //                         <Input placeholder="Email"
    //                         // disabled={this.state.selectedRecord.email ? true : false}
    //                         // className={this.state.selectedRecord.email ? 'input-disabled' : ''}
    //                         />
    //                     )}
    //                 </FormItem>
    //             </Col>

    //         </Row>

    //     </Row>
    //     )
    // }
    // render_USA_address = () => {

    //     const { getFieldDecorator } = this.props.form;
    //     const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };

    //     return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //         <Row gutter={24} style={{marginLeft: '0px', marginRight: '0px'}}>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem
    //                     label="First Name"
    //                 >
    //                     {getFieldDecorator('firstName', {
    //                         rules: [{required: true, message: 'Enter Your First Name!'}],
    //                     })(
    //                         <Input placeholder="First Name"/>
    //                     )}
    //                 </FormItem>
    //             </Col>

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem
    //                     label="Last Name"
    //                 >
    //                     {getFieldDecorator('lastName', {
    //                         rules: [{required: true, message: 'Enter Your Last Name!'}],
    //                     })(
    //                         <Input placeholder="Last Name"/>
    //                     )}
    //                 </FormItem>
    //             </Col>

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem 
    //                     label="Phone"
    //                 >
    //                     {getFieldDecorator('phone', {
    //                         rules: [{ required: true, min: 7, max: 15, message: 'Must be between 7 and 15 characters!' },
    //                             { pattern: new RegExp("^[0-9]*$"), message: 'Enter only Numeric!' }],
    //                     })(
    //                         <Input
    //                             addonBefore={
    //                                 getFieldDecorator(`phonecountryID`, {
    //                                     rules: [{ required: true, message: 'Select Phone Country ID' }],
    //                                     initialValue: '636'
    //                                 })(
    //                                     <Select style={{ width: 120 }}  >
    //                                         {this.getPhoneCode()}
    //                                     </Select>
    //                                 )
    //                             } 
    //                             placeholder="Phone"   
    //                         />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //         </Row>

    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                     <FormItem hasFeedback
    //                         label="Email"
    //                     >
    //                         {getFieldDecorator('email', {
    //                             rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
    //                         })(
    //                             <Input placeholder="Email"/>
    //                         )}
    //                     </FormItem>
    //             </Col>
                
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem
    //                     label="Country"
    //                 >
    //                     {getFieldDecorator('countryId', {
    //                         initialValue: "616",
    //                         rules: [{ required: true, message: 'Enter Your Country!' }],
    //                     })(
    //                         <Select
    //                             // className={this.state.scoutsCountry ? 'input-disabled' : ''}
    //                             // disabled={this.state.scoutsCountry ? true : false}
    //                             showAction={['focus', 'click']}
    //                             showSearch
    //                             style={{ width: '100%' }}
    //                             placeholder="Select a Country"
    //                             optionFilterProp="children"
    //                             onChange={(e) => {
    //                                 this.changeScoutsCountry(e)
    //                             }}
    //                             filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    //                         >
    //                             {this.countries()}
    //                         </Select>
    //                     )}
    //                 </FormItem>
    //             </Col>

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Address Line 1"
    //                 >
    //                     {getFieldDecorator('addressline1', {
    //                         rules: [{ required: true, message: 'Enter Your Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 1"/>
    //                     )}
    //                 </FormItem>
    //             </Col>
    //         </Row>

    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                     <FormItem hasFeedback
    //                         label="Address Line 2"
    //                     >
    //                         {getFieldDecorator('addressline2', {
    //                             rules: [{ required: false, message: 'Enter Your Address!' }],
    //                         })(
    //                             <Input placeholder="Address Line 2"/>
    //                         )}
    //                     </FormItem>
    //             </Col>
                
    //             { /* Hiding AddressLine 3 as per changes from AAG-1026
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Your Address Line 3"
    //                 >
    //                     {getFieldDecorator('addressline3', {
    //                         // initialValue: this.state.selectedRecord.address3 ? this.state.selectedRecord.address3 : "",
    //                         rules: [{ required: false, message: 'Enter Your Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 3"
    //                         // className={this.state.selectedRecord.address3 ? 'input-disabled' : ''}
    //                         // disabled={this.state.selectedRecord.address3 ? true : false} 
    //                         />
    //                     )}
    //                 </FormItem>
    //                     </Col> */}

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="City"
    //                 >
    //                     {getFieldDecorator('city', {
    //                         rules: [{ required: true, min: 2, message: 'Enter Your City!' }],
    //                     })(
    //                         <Input placeholder="City"/>
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="State"
    //                 >
    //                     {getFieldDecorator('state', {
    //                         rules: [{ required: true, message: 'Enter Your State!' }],
    //                     })(
    //                         <Select
    //                             // disabled={this.state.selectedRecord.stateId ? true : false}
    //                             getInputElement={stateInputEle}
    //                             showAction={['focus', 'click']}
    //                             showSearch
    //                             style={{ width: '100%', textTransform: 'uppercase' }}
    //                             placeholder="Select a State"
    //                             optionFilterProp="children"
    //                             filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    //                         >
    //                             {this.statesID()}
    //                         </Select>
    //                     )}
    //                 </FormItem>
    //             </Col>


    //         </Row>

    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="ZIP Code"
    //                 >
    //                     {getFieldDecorator('zipcode', {
    //                         rules: [{ required: true, max: 5, message: 'Enter Your ZIP Code!' }],
    //                     })(
    //                         <Input placeholder="ZIP Code"maxLength={5}/>
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             {/* //AAG-971 Remove 'Scout's Phone Number from NESA application process */}
    //             {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Your Phone"
    //                 >
    //                     {getFieldDecorator('phone', {
    //                         // initialValue: this.state.selectedRecord.phone ? (this.state.PhoneNumber) ? this.state.PhoneNumber.toString() : this.state.selectedRecord.phone.toString() : '',
    //                         rules: [{ required: true, min: 10, max: 10, message: 'Enter Your Phone Number!' },
    //                         {
    //                             pattern: new RegExp("^[0-9]*$"),
    //                             message: "Phone Number must be all numeric!"
    //                         }],
    //                     })(
    //                         <Input
    //                             // className={this.state.PhoneNumber ? 'input-disabled' : ''}
    //                             // disabled={(this.state.PhoneNumber) ? true : false}
    //                             addonBefore={
    //                                 getFieldDecorator('phonecountryID', {
    //                                     rules: [{ required: true, message: 'Select Phone Country ID' }],
    //                                     initialValue: this.state.phoneCountryId ? `${this.state.phoneCountryId}` : "636",
    //                                     // initialValue:  "636",
    //                                 })(
    //                                     <Select style={{ width: 100 }} ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()}>
    //                                         {this.getPhoneCode()}
    //                                     </Select>
    //                                 )
    //                             } />
    //                     )}
    //                 </FormItem>
    //             </Col> */}
    //         </Row>

    //         {/* <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //             <FormItem label={""} className='span-heading'>
    //                 {getFieldDecorator('confirmationBox', {
    //                     // rules: [{ required: true, message: 'Please confirm it before saving the changes!' }],
    //                 })(
    //                     <Checkbox
    //                         onClick={(e) => this.changeAlternateShippingAddress(e, 'confirmationBox')}   
    //                         className='ShippingAlternateCheckbox'
    //                     >
    //                         Alternate Shipping Address
    //                         <label>
    //                             awards and certificates will be shipped to your home address unless Alternate
    //                             Shipping Address is selected.
    //                         </label>
    //                     </Checkbox>

    //                 )}
    //             </FormItem>
    //         </Row> */}
    //     </Row>
    //     )
    // }

    renderEagleInfo = () => {

        if (this.state.selectedRecord) {
            const { getFieldDecorator } = this.props.form;
            let eagleinfo = this.state.selectedRecord
            let isEagle = eagleinfo.eagleBoardReviewDate != null ? true : false

            return <Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8} className='eagle-scout-unit'>
                        <FormItem
                            label={(
                                <span>
                                    Eagle Scout Member ID&nbsp;
                                    <Tooltip placement="top" title="Your MemberID associated with your BOR date">
                                        <Icon type="info-circle-o" />
                                    </Tooltip>
                                </span>
                            )}
                        >
                            {getFieldDecorator('memberid', {
                                initialValue: eagleinfo ? eagleinfo.memberId ? eagleinfo.memberId : '' : '',
                                // rules: [{ required: true, message: 'Enter Member ID!' }],
                            })(
                                <Input className={eagleinfo ? eagleinfo.memberId ? "input-disabled" : '' : ''} disabled={eagleinfo ? eagleinfo.memberId ? true : false : false} placeholder="Eagle Scout Member ID" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label="Eagle Scout Board of Review Date"
                            hasFeedback
                            validateStatus={this.state.isVaildDate}
                            onClick={() => this.setState({ scouts_BOR: '-' })}
                        >
                            {getFieldDecorator('review_date', {
                                initialValue: eagleinfo ? eagleinfo.eagleBoardReviewDate ? moment(eagleinfo.eagleBoardReviewDate).format('MM/DD/YYYY') : '' : '',
                                rules: [
                                    { required: true, message: 'Enter Eagle Scout Board of Review Date!' },
                                    {
                                        pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                    }
                                ],
                            })(
                                // <DatePicker disabled={isEagle} style={{ width: '100%' }} placeholder='MM/DD/YYYY' format="MM/DD/YYYY" />
                                <InputMask
                                    mask="99/99/9999"
                                    style={eagleinfo ? eagleinfo.eagleBoardReviewDate ? { background: '#f5f5f5 ' } : { background: '#fff' } : { background: '#fff' }}

                                    // disabled={eagleinfo ? eagleinfo.eagleBoardReviewDate ? true : false :false}
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={this.state.scouts_BOR}
                                    className="ant-input"
                                    onChange={(e) => {
                                        this.format_Date(e, 'BOR')
                                    }}
                                    render={(ref, props) => (
                                        <Input /> //disabled={eagleinfo ? eagleinfo.eagleBoardReviewDate ? true : false :false}  />
                                    )}
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label={(
                                <span>
                                    Eagle Scout Unit Number&nbsp;
                                    <Tooltip placement="top" title="Please Enter Four Digit Unit Number. Eg: 0001, 0018, 0234">
                                        <Icon type="question-circle-o" />
                                    </Tooltip>
                                </span>
                            )}
                        >
                            {getFieldDecorator('scout_unit', {
                                initialValue: eagleinfo ? eagleinfo.unitNumber ? eagleinfo.unitNumber : '' : "",
                                rules: [
                                    // {required:true},
                                    { max: 4, message: 'Unit Number must be four digits!' },
                                    {
                                        pattern: new RegExp("^[0-9]*$"),
                                        message: "Unit Number must be all numeric!"
                                    }],
                            })(
                                <Input  disabled={eagleinfo ? eagleinfo.unitNumber ? true : false : false} maxLength={4} placeholder="Eagle Scout Unit " />
                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label=" Eagle Scout Unit City"
                        >
                            {getFieldDecorator('scout_city', {
                                initialValue: isEagle ? eagleinfo.eagleCity : "",
                                rules: [{
                                    // required: true,
                                    message: 'Enter Your Eagle Scout Unit City!'
                                }],
                            })(
                                <Input disabled={isEagle} className={isEagle ? "input-disabled" : ''} placeholder="Eagle Scout Unit City" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label=" Eagle Scout Unit State"
                        >
                            {getFieldDecorator('scout_state', {
                                initialValue: isEagle ? eagleinfo.eagleState : "",
                                rules: [{
                                    // required: true,
                                    message: 'Enter Your Eagle Scout Unit State!'
                                }],
                            })(
                                <Select
                                    disabled={isEagle}
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Select a State"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {this.statesID()}
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        {/* <FormItem
                        label="Eagle Council"
                    >
                        {getFieldDecorator('scout_council', {
                            initialValue: isEagle ? eagleinfo.eagleCouncilName : "",
                            // rules: [{ required: true, message: 'Enter your Eagle Scout Unit City!' }],
                        })(
                            <Input disabled={isEagle} className={isEagle ? "input-disabled" : ''} placeholder="Eagle Council Name" />
                        )}
                    </FormItem> */}
                    </Col>
                </Row>
            </Row>
        }
        else {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Eagle information..." />
                </Col>
            </Row>
        }
    }


    ethnicities = () => {
        if (this.props.ethnicities) {
            let ethnicitiesArray = this.props.ethnicities
            return ethnicitiesArray.map((k, index) => {
                return (
                    <option key={index} value={k.short}>{k.name}</option>
                )
            })
        }
    }

    setAddress = (address) => {
        this.setState({
            Address: address
        })
    }

    changeEthinicity = (e) => {
        this.setState({
            ethnic: e
        })
    }

    isEditMode = (editmode) => {
        if (editmode) {
            this.setState({
                hideNext: false
            })
        } else {
            this.setState({
                hideNext: true
            })
        }
    }

    renderpersonalInfo = () => {
        if (this.props.profileloading) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Personal Information..." />
                </Col>
            </Row>
        }
        if (this.props.profileinfo) {
            const { getFieldDecorator } = this.props.form;
            let profileInfo = this.props.profileinfo
            let personemail = this.props.profileinfo.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
            let email = personemail ? personemail.email : ""
            let address = this.props.profileinfo.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
            if (this.state.Address == '') {
                this.setAddress(address)
            }
            let personethnicity = this.props.profileinfo.extendedProfile.filter((data) => data.attributeId == "1")[0]
            return <Row gutter={48}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="First Name"
                    >
                        {getFieldDecorator('first_name', {
                            initialValue: profileInfo.profile.firstName,
                            rules: [{ required: false, message: 'Enter your First Name!' }],
                        })(
                            <Input placeholder="First Name" className="input-disabled" disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="Last Name"
                    >
                        {getFieldDecorator('last_name', {
                            initialValue: profileInfo.profile.lastName,
                            rules: [{ required: false, message: 'Enter your Last Name!' }],
                        })(
                            <Input placeholder="Last Name" className="input-disabled" disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="Email"
                    >
                        {getFieldDecorator('email', {
                            initialValue: email,
                            rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
                        })(
                            <Input placeholder="Email" />
                        )}
                    </FormItem>
                </Col>
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="Ethnic Background"
                    >
                        {getFieldDecorator('ethnic_background', {
                            initialValue: (personethnicity && personethnicity.attributeVal && this.state.ethnic == '') ? personethnicity.attributeVal : this.state.ethnic,
                            rules: [{ 
                                // required: true,
                                 message: 'Enter your Ethnic Background!' }],
                        })(
                            <Select style={{ width: '100%' }} onChange={this.changeEthinicity.bind(this)} >
                                {this.ethnicities()}
                            </Select>
                        )}
                    </FormItem>
                </Col> */}
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Certificate Date"
                            onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                        >
                            {getFieldDecorator('certificate_date', {
                                initialValue:  '',
                                rules: [{ required: true, message: 'Enter the Certificate Date!' }],
                            })(
                                <InputMask
                                    // style={{ background: '#f5f5f5 ' }}
                                    className="ant-input"
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={'-'}
                                    onChange={(e) => {
                                        this.format_Date(e, "C_DATE")
                                    }}
                                    render={(ref, props) => (
                                        <Input />
                                    )} />
                            )}
                        </FormItem>
                    </Col> */}
            </Row>
        }

        return <Row>
            <Col span={24}>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Personal Information..." />
            </Col>
        </Row>
    }

    renderPayNowButton = () => {
        if (this.props.initloading) {
            return <FormItem> <Button type="primary" className='submit-btn' id='goToCart-btn' loading > Loading ...</Button></FormItem>
        } else {
            return (
                <FormItem>
                    <Button type="primary" style={{ width: '100%' }} className='submit-btn' id='goToCart-btn' onClick={() => this.InitTrans()} > Pay Now</Button>
                </FormItem>
            )
        }
    }

    renderPaymentButton = () => {

        if ((this.props.response && this.props.createdPayments) && !BackBtn) {
            this.next()
        }
        if (this.props.loading || this.props.gettingShoppingcart || this.props.creatingPayments) {
            return <FormItem> <Button type="primary" style={{ width: '100%' }} className='submit-btn' id='backToSearch-btn' loading > Loading ...</Button></FormItem>
        } else {
            if (this.state.hideNext) {
                return <FormItem> <Button type="primary" style={{ width: '100%' }} className='submit-btn' id='backToSearch-btn' htmlType='submit' >NEXT</Button> </FormItem>
            }
        }
    }

    componentDidMount = () => {
        // if (this.props.location.search) {
        //     const urlParams = new URLSearchParams(this.props.location.search)
        //     let session = urlParams.get('session')
        //     let SessionValue = base64.decode(session);
        //     localStorage.setItem('user', SessionValue)
        // }
        // const loggedinUser = JSON.parse(localStorage.getItem('user'))
        // let personGUID = loggedinUser.personGuid;
        // this.props.actions.getProfileInfo(personGUID)
        this.props.actions.getProductPrice()
        this.props.actions.getNESAmembershiplevels()
        this.props.actions.getEthnicities()
        this.props.actions.getStates()
        this.props.actions.getCountries()
        this.props.actions.getPhoneCountries()
        // this.props.actions.getEagleInfo()
    }

    componentDidUpdate(prevProps) {
  if (
    !prevProps.regError &&
    this.props.regError &&
    this.state.receipt_loading
  ) {
    this.setState({ receipt_loading: false });

    const { errorCode, message, errorDesc } = this.props.regError;

    Modal.error({
      title: `Error ${errorCode || ""}`,
      content: (
        <div>
          <p><b>{message || "Request failed"}</b></p>
          {errorDesc && <p>{errorDesc}</p>}
        </div>
      )
    });
  }
}

    componentWillReceiveProps = (nextprops) => {
        if (nextprops.ethnicitiesError || nextprops.productpriceError || nextprops.nesa_levelsError || nextprops.allstatesError || nextprops.countriesError || nextprops.phonecodeError){
            const failedLookups = [];
            if (nextprops.ethnicitiesError) failedLookups.push("Ethnicities")
            if (nextprops.productpriceError) failedLookups.push("Product Price")
            if (nextprops.nesa_levelsError) failedLookups.push("Nesa Levels")
            if (nextprops.allstatesError) failedLookups.push("States")
            if (nextprops.countriesError) failedLookups.push('Countries')
            if (nextprops.phonecodeError) failedLookups.push('Phonecode')
            this.setState({ showLookupError: true, pageLoader: false, failedLookups });
        }

        if (nextprops.allstates && nextprops.allstates.length > 0 &&
            nextprops.ethnicities && nextprops.ethnicities.length > 0 &&
            nextprops.countries && nextprops.countries.length > 0 &&
            nextprops.phonecode && nextprops.phonecode.length > 0 &&
            nextprops.productprice && nextprops.productprice.length > 0 &&
            nextprops.nesa_levels && nextprops.nesa_levels.length > 0) 
            {
            this.setState({ lookupsLoaded: true, showLookupError: false, pageLoader: false });
        }

        if (this.props.applingPromocode !== nextprops.applingPromocode) {
            if (nextprops.applingPromocode) {
                this.setState({
                    applingPromocode: true
                })
            }
            if (!nextprops.applingPromocode) {
                this.setState({
                    applingPromocode: false
                })
            }
        }
        if (this.props.PromocodeAdded !== nextprops.PromocodeAdded) {
            if (nextprops.PromocodeAdded) {
                // let TotalAmount = this.state.TotalAmount;
                // let DiscountAmount = (nextprops.PromocodeAdded).toFixed(2);
                // let membershipCost = parseFloat(parseFloat(this.state.SelectedMembershipPrice) - parseFloat(DiscountAmount)).toFixed(2)

                // let transactionFee = (((parseFloat(membershipCost) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                // let totalPrice = this.state.isPayTransactionFees ? (
                //     (parseFloat(TotalAmount) - parseFloat(DiscountAmount) - parseFloat(this.state.transactionFee)) + parseFloat(transactionFee) 
                // ) 
                // : (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                // totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
                this.setState({
                    // transactionFee,
                    // TotalAmount: totalPrice,
                    PromocodeApplied: true,
                    isPromoCodeEditable: true,
                    PromocodeError: false,
                    // DiscountAmount: DiscountAmount,
                    // DiscountCode: nextprops.promoCode
                    // // TotalAmount: (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                })
            }
        }
        if (this.props.shoppingCartList !== nextprops.shoppingCartList && nextprops.shoppingCartList) {
            let transactionFee = 0;
            let shipping_handlingCharge = 0;
            let remainingMembershipAmount = 0;
            let SelectedMembershipPrice = 0;
            let DiscountAmount = 0;
            let DiscountCode = '';
            nextprops.shoppingCartList.shoppingCart.map(cartList => {
                if (cartList.feeStructureCode === "OLRADMIN") {
                    return transactionFee = parseFloat(cartList.amount).toFixed(2)
                }
                // if(cartList.feeStructureCode === "NESALIFECREDIT" ) {
                //     return remainingMembershipAmount = parseFloat(cartList.amount)
                // }
                if (cartList.feeStructureCode === 'NESA-5Year' || cartList.feeStructureCode === 'NESA-Lifetime' || cartList.feeStructureCode === "NESALIFECREDIT" || cartList.feeStructureCode === "NESA5NE-5Year" || cartList.feeStructureCode === "NESANE-LT") {
                    return SelectedMembershipPrice = parseFloat(cartList.amount).toFixed(2)
                }
                if (cartList.product.includes('Shipping/Handling')) {
                    return shipping_handlingCharge = parseFloat(cartList.amount).toFixed(2)
                }
                if (cartList.feeStructureCode.includes('PROMO')) {
                    DiscountCode = cartList.promoCode
                    return DiscountAmount = parseFloat(cartList.amount).toFixed(2)

                }
            })

            this.setState({
                transactionFee,
                remainingMembershipAmount,
                shipping_handlingCharge,
                SelectedMembershipPrice,
                DiscountAmount,
                DiscountCode,
                TotalAmount: nextprops.shoppingCartList.totalAmountDue
            })
        }
        if (this.props.PromocodeRemoved !== nextprops.PromocodeRemoved) {
            if (nextprops.PromocodeRemoved) {
                this.props.form.setFieldsValue({
                    promocode: '',
                });
                // let transactionFee = (((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                // let TotalAmount = (parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge) + (this.state.isPayTransactionFees ? parseFloat(transactionFee) : 0)).toFixed(2)

                // let TotalAmount = this.state.TotalAmount;
                // let DiscountAmount = (nextprops.PromocodeAdded).toFixed(2);
                // let membershipCost = parseFloat(parseFloat(this.state.SelectedMembershipPrice) - parseFloat(DiscountAmount)).toFixed(2)

                // let transactionFee = (((parseFloat(membershipCost) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                // let totalPrice = this.state.isPayTransactionFees ? (
                //     (parseFloat(TotalAmount) - parseFloat(DiscountAmount) - parseFloat(this.state.transactionFee)) + parseFloat(transactionFee) 
                // ) 
                // : (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                // totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
                this.setState({
                    // transactionFee,
                    // TotalAmount: TotalAmount,
                    isPromocodeRemoved: true,
                    PromocodeError: false,
                    PromocodeApplied: false,
                    isPromoCodeEditable: true,
                    // DiscountAmount: 0,
                    DiscountCode: ''

                    // TotalAmount: (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                })
            }
        }
        if (this.props.PromocodeError !== nextprops.PromocodeError) {
            if (nextprops.PromocodeError) {
                this.setState({
                    PromocodeError: true
                })
            }
        }
        if (this.props.response !== nextprops.response) {
            if (nextprops.response) {
                this.setState({
                    membershipRecords: nextprops.response,
                })
            }
        }
        if (this.props.createdPayments !== nextprops.createdPayments) {
            if (nextprops.createdPayments) {
                this.setState({
                    createdPayments: nextprops.createdPayments,
                    current: 3
                })
            }
        }
        if (this.props.initTransaction !== nextprops.initTransaction) {
            if (nextprops.initTransaction) {
                let isPromoCodeEditable = !this.state.PromocodeApplied
                this.setState({
                    isPromoCodeEditable,
                    current: 4
                })
            }
        }
        if (this.props.nesa_reg !== nextprops.nesa_reg) {
            let nesareg = nextprops.nesa_reg ? nextprops.nesa_reg : []
            let nesalevels = nextprops.nesa_levels ? nextprops.nesa_levels : [];

            let membership_Type = '';
            let membershipId = '';
            let expiryDate = '';
            let currentDate = new Date();

            if (nesareg.length == 0 && nesareg != "error") {
                const isApplicableForNewEagle = this.checkApplicableForNewEagle(this.state.selectedRecord.eagleBoardReviewDate);
                this.setState({
                            doesShowNewMemberGreetings: isApplicableForNewEagle,
                            isApplicableForNewEagle
                })
            } else {
                this.setState({
                    doesShowNewMemberGreetings: false,
                    isApplicableForNewEagle: false
                 })
            }

            if (nesareg.length != 0 && nesalevels.length != 0 && nesareg != "error") {
                let haveLifeTime = nesareg.find(item => item.programId.toString() == '32')
                if (haveLifeTime) {
                    this.setState({
                        existingLifePlan: true
                    })
                } else {
                    nesareg.map((k, index) => {
                        if (k.isActive === true) {
                            membershipId = k.programId
                            expiryDate = k.expireDate
    
                            nesalevels.map((j, index) => {
                                if (parseInt(j.id) == membershipId) {
                                    membership_Type = j.name;
                                }
                            })
                        }
                    
                    if(moment(new Date(expiryDate)).isAfter(new Date(currentDate))) {
                            history.push({pathname: "/renew-membership", state: {renewMembership: true, scouts_DOB:this.state.scouts_DOB, SelectedMembershipName: this.state.SelectedMembershipName, redirectedFrom: 'purchase-membership' }})
                        }
                })
                }
                
            }
        }
        if (this.props.searchedEagle !== nextprops.searchedEagle 
            && (Array.isArray(nextprops.searchedEagle) && nextprops.searchedEagle.length > 0) 
            && this.state.lookupsLoaded) 
            {

            let searchedEagle = nextprops.searchedEagle;

                let filterSearchedEagle;
                // if (searchedEagle.length >= 1) {
                filterSearchedEagle = searchedEagle.filter(each => {
                    return each.eagleBoardReviewDate != "" && each.eagleBoardReviewDate != null && each.eagleCertificationDate != "" && each.eagleCertificationDate != null && each.memberId != '' && each.memberId != null
                })
                //     } else {
                //         filterSearchedEagle = searchedEagle
                //    }
                if (this.props.allstates) {
                    filterSearchedEagle.map(eachRec => {
                        this.props.allstates.map(item => {
                            if (item.short == eachRec.state) {
                                eachRec.stateId = item.id
                            }
                        })
                    })
                }

                let length = filterSearchedEagle.length
                //AAG-971 Remove 'Scout's Phone Number from NESA application process
                // let phoneCountryId = ""
                // let PhoneNumber = ""
                // if (length > 0) {
                //     let getCountryName = filterSearchedEagle[0].country.toLowerCase();
                //     if (this.props.phonecode) {
                //         this.props.phonecode.map(code => {
                //             let phoneCountryShort = code.name.toLowerCase();
                //             if (getCountryName == phoneCountryShort) {
                //                 phoneCountryId = code.id
                //             }
                //         })
                //     }
                //     PhoneNumber = filterSearchedEagle[0].phone;
                // } else if (length > 0) {
                //     PhoneNumber = filterSearchedEagle[0].phone.replace(/ /g, '');
                // }

            if (length === 0) {
                this.show_NoResultsFound_Modal();
            } else {
                this.setState({ NoResultsFound: false });
            }

            if (length == 1) {
                // const current = this.state.current + 1;
                // this.props.actions.getProfileInfo(filterSearchedEagle[0].personGuid)
                // this.props.actions.getAlumniEagleInfo(filterSearchedEagle[0].personGuid)
                if (filterSearchedEagle[0].isDeceased) {
                    this.setState({
                        isDeceasedPerson: true
                    })
                } else {
                    let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)


                    this.props.actions.getNESARegistrations(filterSearchedEagle[0].personGuid, true);
                    this.setState(
                        {
                            current: 2,
                            isDeceasedPerson: filterSearchedEagle[0].isDeceased,
                            personGUID: filterSearchedEagle[0].personGuid,
                            EagleResults: filterSearchedEagle,
                            selectedRecord: filterSearchedEagle[0],
                            scoutsCountry: filterSearchedEagle[0].countryId,
                            // phoneCountryId,
                            // PhoneNumber, //AAG-971 Remove 'Scout's Phone Number from NESA application process
                            getValidEagleState: getValidEagleDetails.getValidEagleState,
                            getValidEagleCity: getValidEagleDetails.getValidEagleCity
                        }
                    );
                }

            }
                if (length > 1) {
                    this.showResults()
                    let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)
                    this.setState({
                        // showResultModal: true,
                        // phoneCountryId, //AAG-971 Remove 'Scout's Phone Number from NESA application process
                        // PhoneNumber,
                        selectedRecord: filterSearchedEagle[0],
                        scoutsCountry: filterSearchedEagle[0].countryId,
                        EagleResults: filterSearchedEagle,
                        personGUID: filterSearchedEagle[0].personGuid,
                        getValidEagleState: getValidEagleDetails.getValidEagleState,
                        getValidEagleCity: getValidEagleDetails.getValidEagleCity
                    })
                }
                // if (length === 0)
                //     this.show_NoResultsFound_Modal()
            }
            if (this.props.searchedEagle !== nextprops.searchedEagle 
                && (Array.isArray(nextprops.searchedEagle) && nextprops.searchedEagle.length == 0)) 
                {
                    //show no record found popup
                    this.NoResultsMatchMyProfileAlert()

            }

    }

    showIneligibleStatusModal = () => {
        this.setState({
            ShowIneligibleStatus: true
        })
    }

    closeIneligibleStatusModal = () => {
        this.setState({
            ShowIneligibleStatus: false
        })
    }

    CloseIneligibleToDashboard = () => {
        this.setState({
            ShowIneligibleStatus: false
        })
        // history.push('/')
    }

    showSearchStatus = (title, text) => {
        Modal.warning({
            title: title,
            content: text,
        });
    }
    componentWillUnmount() {
        clearInterval(this.loadingInterval)
    }

    showResults = () => {
        this.setState({
            showResultModal: true
        })
    }

    closeResult = () => {
        this.setState({
            showResultModal: false
        })
    }
    closeNorecordsMatchProfile = () => {
        this.setState({
            NoResultsMatchProfile: false
        })
        // history.push('/my-profile')
    }

    show_NoResultsFound_Modal = () => {
        this.setState({
            NoResultsFound: true
        })
    }
    close_NoResultsFound_Modal = () => {
        this.setState({
            NoResultsFound: false
        })
        // history.push('/my-profile')
    }
    renderSearchButton = () => {
        if (this.props.response && !BackBtn) {
            this.next()
        }
        // if (this.props.loading) {
        //     return <FormItem> <Button type="primary" className='submit-btn' style={{ margin: 0, float: 'unset', width: "100%" }} loading > Loading ...</Button></FormItem>
        // } else {
        return <FormItem> <Button type="primary" className='submit-btn' id='goToCart-btn' style={{ margin: 0, float: 'unset', width: "100%" }} htmlType='submit'>{this.props.searching ? "Searching..." : "SEARCH"}</Button> </FormItem>
        // }
    }

    renderSearchResults = () => {
        if (this.state.EagleResults.length !== 0) {
            return this.state.EagleResults.map((eagle, i) => {
                return (<div className={this.state.memberSelectedKey == i ? 'eagle-results-active' : 'eagle-results'}
                    key={i} onClick={() => {
                        if (eagle.isDeceased) {
                            this.setState({
                                isDeceasedPerson: true
                            })
                        } else {
                            this.SelectedMemberRecord(eagle, i)
                            this.props.actions.getNESARegistrations(eagle.personGuid, true);
                        }

                    }}
                >
                    <Row>
                        <Col xs={23}>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Scout Name: </b></span><span> {`${eagle.firstName} ${eagle.middleName} ${eagle.lastName}`} </span>
                                </Col>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Member ID: </b></span><span>   {eagle.memberId ? eagle.memberId : '---'}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Board of Review Date:  </b></span><span>  {eagle.eagleBoardReviewDate ? eagle.eagleBoardReviewDate : '---'}</span>
                                </Col>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Awarding Council: </b></span><span>  {eagle.awardingCouncilName ? eagle.awardingCouncilName : '---'} </span>
                                </Col>

                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council Unit Number: </b></span><span> {eagle.eagleTroopNumber ? eagle.eagleTroopNumber : "---"}</span>
                                </Col>

                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council City: </b></span><span>  {eagle.eagleCity ? eagle.eagleCity : '---'}</span>
                                </Col>
                            </Row>
                            <Row>

                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council State: </b></span><span>  {eagle.eagleState ? eagle.eagleState : '---'} </span>
                                </Col>
                            </Row>
                            {/* <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council State: </b></span><span>  {eagle.eagleState ? eagle.eagleState : '---'} </span>
                                </Col>
                            </Row> */}
                        </Col>
                        {
                            this.state.memberSelectedKey == i ?
                                <Col xs={1}>
                                    <i className="fa fa-check-circle margin-right-10 fa-2x SelectedRecord pointer" aria-hidden="true"></i>
                                </Col> : ''
                        }
                    </Row>
                </div>
                )
            });
        }
    }
    NoResultsMatchMyProfileAlert = () => {
        this.setState({
            NoResultsMatchProfile: true,
            showResultModal: false,
        })
    }

    closeExistingLifePlanModal = () => {
        this.setState({
            existingLifePlan: false,
            current: 1
        })
        // history.push('/')
    }

    closeNewMemberGreetingsModal = () => {
        this.setState({
            doesShowNewMemberGreetings: false,
        })
        // history.push('/')
    }

    closeDeceasedPersonPopup = () => {
            this.setState({isDeceasedPerson: false})
    }
    retryToLoadFailedLookups = () => {
        if(this.props.ethnicitiesError) this.props.actions.getEthnicities();
        if(this.props.productpriceError) this.props.actions.getProductPrice();
        if(this.props.nesa_levelsError) this.props.actions.getNESAmembershiplevels();
        if(this.props.allstatesError) this.props.actions.getStates();
        if(this.props.countriesError) this.props.actions.getCountries();
        if(this.props.phonecodeError) this.props.actions.getPhoneCountries();

        this.setState({
            showLookupError: false,
            pageLoader: true
        })
    }

    SelectedMemberRecord = (record, i) => {
        //AAG-971 Remove 'Scout's Phone Number from NESA application process
        // let phoneCountryId = "", PhoneNumber = "";

        // if (record.phone.length == 13) {
        //     let getCountryShort = record.phone.slice(0, 3).toString();
        //     if (this.props.phonecode) {
        //         this.props.phonecode.map(code => {
        //             if (getCountryShort == code.short) {
        //                 phoneCountryId = code.id
        //             }
        //         })
        //     }
        //     PhoneNumber = record.phone.slice(3);
        // } else {
        //     PhoneNumber = record.phone;
        // }

        let getValidEagleDetails = this.getValidEagleStateHandler(record.eagleState, record.eagleCity)
        
        this.setState({
            // phoneCountryId,
            // PhoneNumber, //AAG-971 Remove 'Scout's Phone Number from NESA application process
            isDeceasedPerson: false,
            scoutsCountry: record.countryId,
            memberSelectedKey: i,
            selectedRecord: record,
            personGUID: record.personGuid,
            getValidEagleState: getValidEagleDetails.getValidEagleState,
            getValidEagleCity: getValidEagleDetails.getValidEagleCity
        });
    }


    format_Date = (e, field) => {
        let val = e.target.value.split('/');
        let NumExp = /[0-9]/
        val[0] = NumExp.test(val[0]) ? val[0].startsWith('-') ? val[0].replace("-", '0') : val[0] : '';
        val[1] = NumExp.test(val[1]) ? val[1].startsWith('-') ? val[1].replace("-", '0') : val[1] : '';
        val = val.toString().replaceAll(',', '/');
        let hasNumber = /\d/;
        if (field == "DOB" && hasNumber.test(val)) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    dob: val,
                });
            }, 0)
            this.setState({
                scouts_DOB: val
            })

        } else if (field == "BOR" && hasNumber.test(val)) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    review_date: val,
                });
            }, 0)
        } else if (field == "scout_dob" && hasNumber.test(val)) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    scout_dob: val,
                });
            }, 0)
            this.setState({
                scouts_DOB: val
            })
        }
        // else if (field == "C_DATE" && hasNumber.test(val)) {
        //     setTimeout(() => {
        //         this.props.form.setFieldsValue({
        //             certificate_date: val,
        //         });
        //     }, 0)
        // }

    }

    handleSearchSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                //Checking for NESA ineligible applicant
                // if (this.props.profileinfo && this.props.profileinfo.profile && this.props.profileinfo.profile.ineligibleFlag === true){
                //     this.showIneligibleStatusModal();
                // }else{
                values.scout_dob = this.state.scouts_DOB
                this.props.actions.searchEagle(values)
                // this.setState({
                //     scouts_DOB: values.scout_dob
                // })
                // }
            }
        })
    }

    handlePromoSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.actions.ApplyPromocode(this.state.membershipRecords, values, 'SELF-NESA')
                this.setState({
                    DiscountCode: values.promocode
                })
            }
        })
    }
    handlePromoRemove = () => {
        // e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.actions.RemovePromocode(this.state.membershipRecords, values, 'SELF-NESA')
                // this.setState({
                //     DiscountCode: values.promocode
                // })
            }
        })
    }

    renderScoutsInfo = () => {
        if (this.state.selectedRecord) {
            const { getFieldDecorator } = this.props.form;
            let eagleinfo = this.state.selectedRecord

            let ethnicShort = this.state.selectedRecord.ethnicity;
            let ethnicBackground = undefined;
            if (ethnicShort != "" && this.props.ethnicities) {
                this.props.ethnicities.map(each => {
                    if (each.short == ethnicShort) {
                        ethnicBackground = each.name
                    }
                })
            }
            return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <FormItem hasFeedback
                            label="Your First Name"
                        >
                            {getFieldDecorator('firstname', {
                                initialValue: eagleinfo.firstName ? eagleinfo.firstName : '',
                                rules: [{ message: 'Enter Scout\'s First Name!' }],
                            })(
                                <Input disabled placeholder="First Name" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Middle Initial"
                        >
                            {getFieldDecorator('middlename', {
                                initialValue: eagleinfo.middleName ? eagleinfo.middleName : '',
                                rules: [{ message: 'Enter Scout\'s Middle Name!' }],
                            })(
                                <Input disabled placeholder="Middle Name" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Last Name"
                        >
                            {getFieldDecorator('lastname', {
                                initialValue: eagleinfo.lastName ? eagleinfo.lastName : '',
                                rules: [{ min: 2, message: 'Enter Scout\'s Last Name!' }],
                            })(
                                <Input disabled placeholder="Last Name" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Date of Birth"
                            onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                        >
                            {getFieldDecorator('dob', {
                                initialValue: this.state.scouts_DOB ? moment(this.state.scouts_DOB).format('MM/DD/YYYY') : '',
                                rules: [{ message: 'Enter Date of Birth!' }],
                            })(
                                <InputMask
                                    style={{ background: '#f5f5f5 ' }}
                                    className="input-disabled ant-input"
                                    disabled
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={this.state.scouts_DOB_MaskChar}
                                    onChange={(e) => {
                                        this.format_Date(e, 'DOB')
                                    }}
                                    render={(ref, props) => (
                                        <Input
                                            className="input-disabled" disabled
                                        />
                                    )} />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Member ID"
                        >
                            {getFieldDecorator('memberid', {
                                initialValue: eagleinfo.memberId ? eagleinfo.memberId : '',
                                // rules: [{  min: 2, message: 'Enter Scout\'s Member ID!' }],
                            })(
                                <Input disabled placeholder="Member ID" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem
                            label="Gender"
                        >
                            {getFieldDecorator('gender', {
                                initialValue: eagleinfo.gender ? eagleinfo.gender : '',
                                rules: [{ required: true, message: 'Enter Scout\'s Gender!' }],
                            })(
                                <RadioGroup name="gender" disabled={eagleinfo.gender != '' ? true : false}  >
                                    <Radio value="M">Male</Radio>
                                    <Radio value="F">Female</Radio>
                                </RadioGroup>
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem
                            label="Ethnic Background"
                        >
                            {getFieldDecorator('ethnic', {
                                initialValue: ethnicBackground ? ethnicBackground : '',
                                rules: [{ 
                                    // required: true,
                                     message: 'Enter Scout\'s Ethnic Background!' }],
                            })(
                                <Select style={{ width: '100%' }} disabled={ethnicBackground ? true : false} >
                                    {this.ethnicities()}
                                </Select>
                            )}
                        </FormItem>
                    </Col> */}
                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Certificate Date"
                            onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                        >
                            {getFieldDecorator('certificate_date', {
                                initialValue:  '',
                                rules: [{ required: true, message: 'Enter the Certificate Date!' },
                                {
                                  pattern:/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                  message: `Please enter correct format MM/DD/YYYY Pattern`
                               }],
                            })(
                                <InputMask
                                    // style={{ background: '#f5f5f5 ' }}
                                    className="ant-input"
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={'-'}
                                    onChange={(e) => {
                                        this.format_Date(e, "C_DATE")
                                    }}
                                    render={(ref, props) => (
                                        <Input />
                                    )} />
                            )}
                        </FormItem>
                    </Col> */}
                </Row>
            </Row>)
        }
        else {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Your Personal Information..." />
                </Col>
            </Row>
        }
    }

    render() {
        const { current } = this.state;
        const { minutes, seconds } = this.state
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <NESAHeader />

                <div className='step-widget'>
                    <div className='step-container'>
                        <div className='purchase-membership step-background'>
                            <Row type="flex" align="center" justify="center">
                                <Steps current={current} className='step-i'>
                                    <Step key="level" title="Eagle Level" />
                                    <Step key="eagle-search" title="Eagle Search" />
                                    <Step key="eagle-info" title="Eagle Info" />
                                    <Step key="payment-Summary" title="Summary" />
                                    <Step key="payment" title="Payment" />
                                    <Step key="receipt" title="Receipt" />
                                </Steps>
                            </Row>
                        </div>
                        <div className="steps-content centered ">
                            {this.state.current == 0 &&
                                <div className="centered steps-form1">
                                    <Row type="flex" justify="center" align="center">
                                        <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                            <img src="../NESA.png" className='NESA-logo' />
                                        </Col>
                                        <Col span={24} className="center">
                                            <span className='welcome-text'> Welcome to the National Eagle Scout Association </span>
                                        </Col>
                                        <Col span={24} className="center">
                                            <span className='thank-you'>
                                                NESA membership give your Eagle pride a purpose.
                                                Members like you empower Scouting's mission and protect the Eagle Scout legacy.
                                                We can't wait for you to join us! Select your membership level below.
                                            </span>
                                        </Col>
                                        <Col className="card-margin" span={24}>
                                            <Row gutter={48} className='welcome-nesa-col'>
                                                {this.renderLevels()}
                                            </Row>
                                        </Col>
                                    </Row>
                                    <div className="text-result pointer"
                                        style={{ marginTop: "55px", marginBottom: '55px' }}
                                        onClick={() => {
                                            window.location.assign('https://nesa.org/take-action/join-us/')
                                        }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to NESA.org/ Join
                                    </div>
                                </div>
                            }
                            {this.state.current == 1 &&
                                <div className="centered" style={{ marginBottom: '40px' }} >
                                    <Form onSubmit={this.handleSearchSubmit} className="search-form alumni-ui">
                                        <Row type="flex" justify="center" align="center">
                                            <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                                <img src="../NESA.png" className='NESA-logo' />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='welcome-text'> WELCOME </span>
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='thank-you'>Thank you for your interest in supporting NESA</span>
                                            </Col>

                                            <Col className="card-margin search-alumni" span={24}>
                                                <Card
                                                    className="centered search-alumni-card"
                                                    title="YOUR PERSONAL INFORMATION"
                                                >
                                                    <Row gutter={48}>
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your First Name"
                                                                hasFeedback
                                                            >
                                                                {getFieldDecorator('scout_first_name', {
                                                                    rules: [{ required: true, message: 'Enter Your First Name!' }],
                                                                })(
                                                                    <Input placeholder="First Name" />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                        {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Middle Initial"
                                                                hasFeedback
                                                            >
                                                                {getFieldDecorator('scout_middle_Initial', {
                                                                    rules: [{ required: false, message: 'Enter Your Middle Initial!' }],
                                                                })(
                                                                    <Input placeholder="Middle Initial" />
                                                                )}
                                                            </FormItem>
                                                        </Col> */}
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Last Name"
                                                                hasFeedback
                                                            >
                                                                {getFieldDecorator('scout_last_name', {
                                                                    rules: [{ required: true, message: 'Enter Your Last Name!' }],
                                                                })(
                                                                    <Input placeholder="Last Name" />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Date of Birth"
                                                                hasFeedback
                                                                onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                                                            >
                                                                {getFieldDecorator('scout_dob', {
                                                                    initialValue: '',
                                                                    rules: [
                                                                        { required: true, message: 'Enter Your Date of Birth!' },
                                                                        {
                                                                            pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                                                            message: `Please enter correct format MM/DD/YYYY Pattern`
                                                                        }
                                                                    ],
                                                                })(

                                                                    <InputMask
                                                                        mask="99/99/9999"
                                                                        placeholder='MM/DD/YYYY'
                                                                        alwaysShowMask
                                                                        maskChar={this.state.scouts_DOB_MaskChar}
                                                                        className="ant-input"
                                                                        // value={this.state.scouts_DOB}
                                                                        onChange={(e) => {
                                                                            this.format_Date(e, 'scout_dob')
                                                                        }}
                                                                        render={(ref, props) => (
                                                                            <Input

                                                                            />
                                                                        )}
                                                                    />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                        {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Member ID"
                                                            >
                                                                {getFieldDecorator('scout_member_id', {
                                                                    rules: [{ required: false, message: 'Enter Your Member ID!' }],
                                                                })(
                                                                    <Input placeholder="Member ID" />
                                                                )}
                                                            </FormItem>
                                                        </Col> */}
                                                        {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Board of Review Date"
                                                            >
                                                                {getFieldDecorator('scout_brd', {
                                                                    rules: [{ required: false, message: 'Enter Your Board of Review Date!' }],
                                                                })(
                                                                    <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" />
                                                                )}
                                                            </FormItem>
                                                        </Col> */}
                                                    </Row>
                                                    <Row style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <Col className='xs-center sm-center' xs={14} sm={14} md={8} lg={8} xl={8}>
                                                            {this.renderSearchButton()}
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                    <div className="steps-action center backto-levels">
                                        <Row style={{ position: "unset" }}>
                                            <Col xs={24} sm={24} md={9} lg={7} xl={7}  >
                                                <div className="text-result pointer"
                                                    style={{ marginTop: "55px", marginBottom: '55px' }}
                                                    onClick={() => this.prev()}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Levels</div>
                                            </Col>
                                        </Row>
                                    </div>
                                        </Row>
                                    </Form>
                                </div>
                            }
                            {this.state.current == 2 &&
                                <div className="centered steps-form" >
                                    <Form onSubmit={this.handleSubmit} className="purchase-form alumni-ui" style={{ width: '100%' }}>
                                        <Row type="flex" justify="center" align="center">
                                            <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                                <img src="../NESA.png" className='NESA-logo' />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='welcome-text'> WELCOME </span>
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='thank-you'>Thank you for your interest in supporting NESA</span>
                                            </Col>

                                            {/* Hiding personal information on purchase membership
                                            <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Your Personal Information"
                                                >
                                                    {/*this.renderScoutsInfo()}
                                                </Card>
                                            </Col>
                                            */}

                                            <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Your Eagle Scout Information"
                                                >
                                                    {this.renderEagleInfo()}
                                                </Card>
                                            </Col>

                                            <Col className="card-margin" span={24}>
                                                {this.renderPrimaryOrAlternateAddress()}
                                            </Col>

                                            <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Membership Transaction Fee"
                                                >
                                                    <Row>
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            <div className="Summary-title-txt" style={{ fontSize: '14px' }}>
                                                                Optional Transaction Fee &nbsp;
                                    <Tooltip placement="bottom" title="Please consider covering the transaction fees for this membership purchase">
                                                                    <Icon type="info-circle-o" theme="twoTone" />
                                                                </Tooltip>
                                                            </div>
                                                            {/* <div className="summary-label-txt" style={{ fontSize: '14px' }} ></div> */}
                                                        </Col>

                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                            <div className="summary-label-txt">
                                                                <Switch checked={this.state.isPayTransactionFees} onChange={() => this.calculateFee()} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {/* <Row >
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            <div className="summary-label-txt" style={{ fontSize: '14px' }} >Transaction Fees</div>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                            <div className="summary-label-txt">$ {this.state.transactionFee} </div>
                                                        </Col>
                                                    </Row> */}
                                                </Card>
                                            </Col>

                                            <div className="steps-action centered" style={{ width: '100%' }}>
                                                <Row style={{ position: "unset" }}>
                                                    <Col xs={24} sm={24} md={9} lg={7} xl={7}  >
                                                        <div className="text-result pointer"
                                                            style={{ marginTop: "55px", marginBottom: '55px' }}
                                                            onClick={() => {
                                                                // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                                                // this.setState({
                                                                //     current: 0,
                                                                //     isPayTransactionFees: false,
                                                                //     TotalAmount: total
                                                                // })
                                                                // history.push('/purchasee-membership')
                                                                this.prev()
                                                            }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Search</div>
                                                    </Col>
                                                    <Col className='xs-center sm-center ' xs={24} sm={24} md={7} lg={7} xl={7} offset={2}>
                                                        <FormItem>
                                                            <Button type="primary" style={{ width: '100%' }} className='back-btn' id='goToCart-btn' onClick={() => this.prev()}>This is not me</Button>
                                                        </FormItem>
                                                    </Col>
                                                    <Col className='xs-center sm-center' xs={24} sm={24} md={7} lg={7} xl={7} offset={1}>
                                                        <FormItem>
                                                            {this.renderPaymentButton()}
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                            </div>


                                        </Row>

                                    </Form>
                                </div>
                            }
                            {this.state.current == 3 &&
                                this.renderPaymentSummary()
                            }
                            {this.state.current == 4 &&
                                <div>
                                    <div className="centered steps-payment">
                                        <Row className='margin-top-30 payment-row' gutter={48} type="flex" justify="space-between" align="center">
                                            <Col xs={24} sm={24} md={24} lg={16} className="payment-col">
                                                <Card
                                                    className="margin-top-30"
                                                    title="Payment Information"

                                                >
                                                    <Row>
                                                        <Col span={10}>
                                                            <div className="checkbox-card-icon-wrapper">
                                                                <Row>
                                                                    <Col span={10}>
                                                                        <div className="title-txt margin-top-10" style={{ fontSize: '16px' }}>Credit Card</div>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <img src='../credit-card.png' height={40} />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Spin tip={`Please do not close the browser until the Receipt is displayed! \n  Redirecting in ${seconds} seconds...`} style={{ whiteSpace: "break-spaces" }} spinning={this.state.receipt_loading}>
                                                        {this.renderIframe()}
                                                    </Spin>
                                                </Card>
                                            </Col>

                                            <Col xs={24} sm={24} md={24} lg={8} className="summary-receipt-col">
                                                <Card
                                                    className="margin-top-30"
                                                    title="Summary"

                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={12}>
                                                            <span className="title-txt" style={{ fontSize: '16px' }}>Eagle Info</span>
                                                        </Col>
                                                        <Col span={12} className="right">
                                                            <span className="verified"><Icon type="check-circle" /> Verified</span>
                                                        </Col>
                                                        <Col span={24}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname} </span>
                                                        </Col>
                                                        <Col span={24}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.memberId} </span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24}>
                                                            <span className="title-txt" style={{ fontSize: '16px' }}>Level</span>
                                                        </Col>

                                                        <Col span={18}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.SelectedMembershipName}</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.SelectedMembershipPrice}</span>
                                                        </Col>

                                                        {this.state.PromocodeApplied && <Row type="flex" justify="space-between" align="center" style={{ width: '100%' }}>
                                                            <Col span={18}>
                                                                <span className="label-txt green-txt" style={{ fontSize: '14px' }} ><CheckCircleTwoTone twoToneColor="#52c41a" /> {this.state.DiscountCode}</span>
                                                            </Col>
                                                            <Col span={6} className="right">
                                                                <span className="summary-price green-txt" style={{ fontSize: '14px' }}>-$ {this.state.DiscountAmount}</span>
                                                            </Col>
                                                        </Row>}

                                                        {this.state.PromocodeApplied && <Row style={{ width: '100%' }}>
                                                            <Col span={18}>
                                                                <div className="summary-label-txt" style={{ fontSize: '14px' }} >Membership Cost</div>
                                                            </Col>

                                                            <Col span={6} className="right">
                                                                <div className="summary-label-txt">$ {parseFloat(parseFloat(this.state.SelectedMembershipPrice) - parseFloat(this.state.DiscountAmount)).toFixed(2)}</div>
                                                            </Col>
                                                        </Row>}
                                                        {this.state.PromocodeApplied &&
                                                            <Divider style={{ margin: '10px 0px' }} />}

                                                        <Col span={18}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.SelectedMembershipName} S/H</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.shipping_handlingCharge}</span>
                                                        </Col>

                                                    </Row>
                                                    {this.state.isPayTransactionFees && <Row type="flex" justify="space-between" align="center">
                                                        <Col span={18}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >Transaction Fees</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.transactionFee}</span>
                                                        </Col>
                                                    </Row>}

                                                    <hr />
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={12}>
                                                            <span className="title-txt" style={{ fontSize: '16px' }}>Total</span>
                                                        </Col>
                                                        <Col span={12}>
                                                            <span className="price-txt" style={{ fontSize: '14px' }}>$ {this.state.TotalAmount}</span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col className='xs-center sm-center' xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div className="steps-action centered">
                                                    <div className="text-result pointer"
                                                        style={{ marginTop: "55px", marginBottom: '55px' }}
                                                        onClick={() => {
                                                            // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                                            // this.setState({
                                                            //     ShowPaymentSummary: true,
                                                            //     isPayTransactionFees: false,
                                                            //     TotalAmount: total
                                                            // })
                                                            this.prev()

                                                        }}>
                                                        <i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Summary</div>
                                                </div>
                                                {/* <Button type="primary" className='back-btn' onClick={() => this.prev()}>Back to Step 2</Button> */}
                                            </Col>

                                        </Row>
                                    </div>
                                    {this.renderReceiptpage()}
                                </div>
                            }
                            {this.state.current == 5 &&
                                <div>
                                    <div className="centered steps-receipt">
                                        <Row gutter={48} type="flex" className='receipt-row'>
                                            <Col xs={24} sm={24} md={8} lg={8} className="margin-top-30 receipt-col">
                                                <Card
                                                    className=""
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24}>
                                                            <span className="title-txt">Summary</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Name</span>
                                                            <span className="label-txt">
                                                                {this.state.firstname} {this.state.middlename} {this.state.lastname}</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Date</span>
                                                            <span className="label-txt">{moment().format('MM/DD/YYYY')}</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Address</span>
                                                            <span className="label-txt">
                                                                {this.state.address1 && (<React.Fragment>{this.state.address1}<br /></React.Fragment>)}
                                                                {this.state.address2 && (<React.Fragment>{this.state.address2}<br /></React.Fragment>)}
                                                                {this.state.address3 && (<React.Fragment>{this.state.address3}<br /></React.Fragment>)}
                                                                {this.state.city && this.state.userDetails.stateName && (<React.Fragment>{this.state.city}, {this.state.userDetails.stateName}<br /></React.Fragment>)}
                                                                {this.state.zip && (<React.Fragment>{this.state.zip}<br /></React.Fragment>)}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-txt"><b>{this.state.SelectedMembershipName}</b></span>
                                                        </Col>
                                                        <Col span={12} className=''>
                                                            <span className="title-txt">Total</span>
                                                        </Col>
                                                        <Col span={12} className='right'>
                                                            <span className="summary-price"><b>${this.state.TotalAmount}</b></span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14} className="margin-top-30 receipt-col">
                                                <Card
                                                    className="receipt-header"
                                                    title="National Eagle Scout Association"
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24} className='right'>
                                                            <img src="../NESA.png" className='receipt-logo' />
                                                        </Col>
                                                        <Col>
                                                            <p>{INDIVIDUAL_PURCHASE.PARAGRAPH1}</p>
                                                            <p>{INDIVIDUAL_PURCHASE.PARAGRAPH2}</p>
                                                            <p>{INDIVIDUAL_PURCHASE.PARAGRAPH3}</p>
                                                            <p>{INDIVIDUAL_PURCHASE.PARAGRAPH4}</p>
                                                            <p>{INDIVIDUAL_PURCHASE.PARAGRAPH5} <a href="mailto:NESA@scouting.org">NESA@scouting.org</a></p>

                                                        </Col>
                                                        <Col span={24} className="right signature-block">
                                                            <span>Yours in Scouting</span>
                                                            <img src='JohnStachniak_Signature.jpg' className='director-logo' />
                                                            <span><b>John Stachniak</b></span>
                                                            <span>Director, National Eagle Scout Association</span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14}>
                                                <Button type="primary" className='submit-btn' onClick={() => window.location.assign('https://nesa.org/')}>GO HOME</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="steps-action centered">
                            {
                                this.state.current == 0
                                && <div className='membership-bottom'></div>
                            }
                        </div>
                    </div>
                </div>
                <NESAFooter />

                <Modal
                    className='multiple-r-modal'
                    title={false}
                    footer={false}
                    visible={this.state.showResultModal}
                    centered
                    onCancel={() => this.closeResult()}
                >
                    <div>
                        <span className='modal-header'>Multiple Records Found</span>
                        <span className='modal-desc'>Multiple records were found, please select one.</span>
                    </div>

                    {this.renderSearchResults()}

                    <Row type='flex' style={{ justifyContent: 'end', alignItems: 'center' }}>
                        <Col className='xs-center sm-center' xs={24} sm={24} md={24} lg={13} xl={13} >
                            <div className='step-container margin-top-20' >
                                <Button type="primary" className='back-btn' style={{ fontSize: '13px', width: '100%' }} onClick={() => this.NoResultsMatchMyProfileAlert()}>No Search Results Match My Profile</Button>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5} offset={2}>
                            <div className='step-container margin-top-20' >
                                <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                    // this.props.actions.getProfileInfo(this.state.selectedRecord.personGuid)
                                    // this.props.actions.getAlumniEagleInfo(this.state.selectedRecord.personGuid)
                                    this.closeResult();
                                    this.setState({
                                        current: this.state.current + 1
                                    })
                                }} htmlType='submit'>SELECT</Button>
                            </div>
                        </Col>
                    </Row>
                </Modal>
                <Modal
                    className='No-records-match-myMrofile-model'
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsMatchProfile}
                    centered
                    onCancel={() => this.closeNorecordsMatchProfile()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            No Results Match Profile
                        </div>

                        <div className='margin-bottom-20'> Whoops! It appears no current Eagle Scout record matches your Eagle Scout information. Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Scout's Eagle Scout council for further assistance.</div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.closeNorecordsMatchProfile();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    className='No-records-Found-model'
                    style={{ width: '600px' }}
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsFound}
                    centered
                    onCancel={() => this.close_NoResultsFound_Modal()}
                >
                    <div className="center missing-div">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            Missing Information
                        </div>

                        {/* <div className='margin-bottom-20'> Whoops! We found the Scout but there wasn't any Eagle Scout information associated with them.  Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Eagle Scout council for further assistance.</div> */}

                        <div className='margin-bottom-20'> Whoops! it appears there is critical information regarding First Name, Last Name or Date of Birth, missing from your Eagle Scout record. </div>
                        {/* <div style={{color: ' #cc0033', marginBottom: '10px'}}>
                            Firstname, Lastname, Date of Birth
                        </div>
                        <div> please contact your Eagle Scout council for further assistance.</div>
                        <div style={{backgroundColor: "#fce4e4", border: '2px solid #fcc2c3', padding: '10px 20px', margin: '10px 0px', color: ' #cc0033'}}>
                            Missing or incomplete ID records in Akela (the master membership database)
                        </div> */}

                        {/* <div> Note: The missing information would identify the missing or incomplete information needed to complete a NESA application </div>  */}
                        <div> Please contact your Eagle Scout council to update your Eagle information. </div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.close_NoResultsFound_Modal();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    centered
                    className='IneligibleApplicantModal'
                    visible={this.state.ShowIneligibleStatus}
                    onCancel={this.closeIneligibleStatusModal}
                    title="Whoops!"
                    footer={
                        <Button key="submit" type="primary" className="RedirectIneligibleToNESA"
                            onClick={this.CloseIneligibleToDashboard}>
                            Close
                        </Button>
                    }
                >
                    It appears there is a question of your NESA membership eligibility.
                    Please contact your local council for more detailed information.
                </Modal>

                <Modal
                    centered
                    className='ExistingLifeTimePlanModal'
                    visible={this.state.existingLifePlan}
                    closable={false}
                    footer={
                        <Button key="submit" type="primary" className='RedirectExistingLifePlan'
                            onClick={this.closeExistingLifePlanModal}>
                            Close
                        </Button>
                    }
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>

                        <div className='Existing-Lifeplan-Info'>
                            <span className='modal-desc'>You already have an existing NESA Lifetime plan. </span>
                        </div>
                    </div>
                </Modal>
                {this.state.doesShowNewMemberGreetings && <NewEagleGreetingsModal 
                doesShowNewMemberGreetingsProps={this.state.doesShowNewMemberGreetings} 
                closeNewMemberGreetingsModalHandler={this.closeNewMemberGreetingsModal} 
                />}

                <CustomPopupModal 
                doesShowPopup={this.state.isDeceasedPerson} 
                closePopup={this.closeDeceasedPersonPopup} 
                popupTitle={"Invalid Membership Purchase"} 
                popupPrimaryContent={deceasedPopup_primaryConent}
                popupSecondaryContent={deceasedPopup_secondaryConent} 
                />
                
                {this.state.showLookupError && <CustomPopupModal 
                doesShowPopup={this.state.showLookupError} 
                closePopup={this.retryToLoadFailedLookups} 
                popupTitle={"Internal Server Error"} 
                btnText={"RETRY"} 
                popupPrimaryContent={`${failedToLoadLookup_Popup_primaryConent} "${this.state.failedLookups.join(', ')}" lookup data `}
                popupSecondaryContent={failedToLoadLookup_secondaryConent} 
                />
}
                

                <FullPageSpinner spinning={this.state.pageLoader}/>
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: state.authenticationReducer.loggingIn,
        timeout: state.authenticationReducer.timeout,
        initloading: state.chasepaymentreducer.loading,
        initTransaction: state.chasepaymentreducer.initTransaction,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        ethnicitiesError: state.ethnicitiesreducer.error,
        // profileloading: state.profilereducer.loading,
        // profileinfo: state.profilereducer.profileinfo,
        paymentstatus: state.paymentcompletedreducer.status,
        productprice: state.productpricereducer.productprice,
        productpriceError: state.productpricereducer.error,
        productprice_loading: state.productpricereducer.loading,
        nesa_levels_loading: state.nesalevelsreducer.loading,
        nesa_levels: state.nesalevelsreducer.levels,
        nesa_levelsError: state.nesalevelsreducer.error,
        allstates: state.allstatesreducer.states,
        allstatesError: state.allstatesreducer.error,
        // eagleinfo: state.eagleinforeducer.eagleinfo,
        // eagleinfo_loading: state.eagleinforeducer.loading,
        loading: state.purchasemembershipreducer.loading,
        response: state.purchasemembershipreducer.response,
        regstatus: state.regstatusreducer.status,
        searching: state.eagleSearchReducer.searching,
        searchedEagle: state.eagleSearchReducer.eagle,
        // alumnieagleinfo: state.alumnieagleinforeducer.eagleinfo,
        // alumnieagleinfo_loading: state.alumnieagleinforeducer.loading,
        countries: state.countriesreducer.countries,
        countriesError: state.countriesreducer.error,
        phonecode: state.phonecountrycodereducer.code, 
        phonecodeError: state.phonecountrycodereducer.error, 
        registration_loading: state.purchasemembershipreducer.loading,
        applingPromocode: state.promocodereducer.loading,
        PromocodeAdded: state.promocodereducer.response,
        promoCode: state.promocodereducer.promoCode,
        PromocodeRemoved: state.promocodereducer.removedPromoAmount,
        PromocodeError: state.promocodereducer.error,
        creatingPayments: state.PaymentsCreateReducer.loading,
        createdPayments: state.PaymentsCreateReducer.response,
        nesa_reg: state.nesaregistrationreducer.reg,
        gettingShoppingcart: state.shoppingCartReducer.loading,
        shoppingCartList: state.shoppingCartReducer.response,
        regError: state.regstatusreducer.regError,
        
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

const PurchaseMembership = Form.create()(PurchaseMembershipForm);

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseMembership);


// WEBPACK FOOTER //
// ./src/components/Membership/PurchaseMembership.js